export const Paths = {
	base: '/',
	nf: '*',
	forgot: 'forgot',
	// admin: "admin",

	// account
	accountSummary: 'account-summary',
	abBusinessInfo: 'ab-business-info',
	completeLedger: 'complete-ledger',
	abRemainingBalance: 'ab-remaining-balance',
	abTdsTracker: 'ab-tds-tracker',
	panCases: 'pan-cases',
	// reversePayment: "reverse-payment",
	// reversePaymentUpload: "reverse-payment/upload",
	abHolds: 'ab_holds',
	commissionCycle: 'commission_cycle',
	cashBonusCycle: 'cash_bonus_cycle',
	businessProcessing: 'business_processing',
	exportJobsList: 'business_processing/exports',
	gstBusinessProcessing: 'gst_business_processing',
	exportGstJobsList: 'gst_business_processing/exports',
	beneficiaryDetails: 'beneficiary_details',
	exportBeneficiaryJobsList: 'beneficiary_details/exports',
	bankBookSummary: 'bank_book_summary',
	bankBookDetails: 'bank_book_summary/hdfc/:chequeNo',
	sbiBankBookDetails: 'bank_book_summary/sbi/:chequeNo',
	masterRcmBank: 'master_rcm_bank',
	hdfcStatementList: 'hdfc_statement',
	hdfcStatementUpload: 'hdfc_statement/upload',
	hdfcResponseUpload: 'hdfc_response',
	hdfcResponseUploadDetails: 'hdfc_response/:chequeNo',
	abInvoices: 'ab-invoices',
	sapBusinessReport: 'sap_business_report',
	sapPaymentReport: 'sap_payment_report',
	sapTdsReport: 'sap_tds_report',
	missingPan: 'missing-pan',
	exportJobs: 'export_jobs',
	masterBusinessRemark: 'master-business-remark',
	abLoanManager: 'ab-loan-manager',

	// Payment Release
	paymentRelease: 'payment-release',

	// CRM PATH
	Crm: 'crm',
	crmOrders: 'orders',
	crmFailedOrders: 'failed-orders',
	crmFailedOrderView: 'failed-orders/order-view',
	crmBulkUndeliveredQueue: 'bulk-undelivered-queue',
	crmOrderView: 'orders/order-view',
	crmOrderReturn: 'order-returns',
	crmOrderReturnSearch: 'order-returns/order-return',
	crmOrderReturnView: 'order-return/order-return-view',

	//
	users: 'user',

	manageRole: 'manage-role',
	manageUser: 'manage-user',
	manageModules: 'manage-modules',
	editModule: 'manage-modules/edit-module',
	manageBatch: 'batch',
	bulkUploadPv: 'bulk-update-pv',
	ecomABLogin: 'ecom-ab-login',
	updatePrice: 'update-price',
	updateProducts: 'update-products',
	udaanReport: 'udaan-report',
	nirjaraDashboard: 'nirjara-dashboard',
	nirjaraAdminReview: 'nirjara-dashboard/submission',
	ulpQuick: 'ulp-quick',
	swasthyaShivir: 'swasthya-shivir',
	grievanceList: 'grievances',
	ulpQuickRetentionReport: 'ulp-quick-retention-report',
	batchAdd: 'batch/add',
	batchEdit: 'batch/edit',
	tagsList: 'tag',
	addTag: 'tag/add_tag',
	editTag: 'tag/edit_tag',
	categoryList: 'categorylist',
	categoryAdd: 'categorylist/add_category',
	categoryEdit: 'categorylist/edit_category',

	addUser: 'manage-user/add-user',
	editUser: 'manage-user/edit-user',

	addRole: 'manage-role/add-role',
	editRole: 'manage-role/edit-role',

	brandList: 'brand_list',
	brandAdd: 'brand_list/brand_add',
	brandEdit: 'brand_list/brand_edit',

	brandTemplateList: 'brand-template',
	brandTemplateAdd: 'brand-template/add',
	brandTemplateEdit: 'brand-template/edit',

	attributesList: 'attributes_list',
	attributesAdd: 'attributes_list/attributes_add',
	attributesEdit: 'attributes_list/attributes_edit',

	variantsList: 'variants_list',
	variantsAdd: 'variants_list/variants_add',
	variantsEdit: 'variants_list/variants_edit',

	productList: 'product_list',
	productAdd: 'product_list/product_add',
	productEdit: 'product_list/product_edit',

	productAvailabilityTrackingList: 'product-availability-tracking-list',
	productAvailabilityTrackingAdd: 'product-availability-tracking/add',
	productAvailabilityTrackingEdit: 'product-availability-tracking/edit/:id',

	walletList: 'wallet_list',
	walletAdd: 'wallet_list/wallet_add',
	walletEdit: 'wallet_list/wallet_edit',
	mappedList: 'mapped_list',
	mappedAdd: 'mapped_list/mapped_add',
	mappedTdsAdd: 'mapped_list/mapped_tds_add',
	mappedBulkUpload: 'mapped_list/mapped_bulk_upload',
	mappedEdit: 'wallet/mapped_edit',
	walletRemainingBalance: 'wallet_remaining_balance',

	consistencyData: 'consistency-data',
	cashBonusData: 'cash-bonus-data',
	finalCashBonus: 'final-cash-bonus',
	finalRcmConsistency: 'final-rcm-consistency',
	inactiveRegisteredBuyer: 'inactive-registered-buyers',

	couponList: 'coupon_list',
	couponAdd: 'coupon_list/coupon_add',
	couponEdit: 'coupon_list/coupon_edit',

	offersList: 'offers_list',
	offersAdd: 'offers_list/offers_add',
	offersEdit: 'offers_list/offers_edit',

	shippingSequencesList: 'shipping_sequences_list',
	shippingSequencesAdd: 'shipping_sequences_list/shipping_sequences_add',
	shippingSequencesEdit: 'shipping_sequences_list/shipping_sequences_edit',

	sequenceMapppingList: 'sequence_mapping_list',
	sequenceMapppingAdd: 'sequence_mapping_list/sequence_mapping_add',
	sequenceMapppingEdit: 'sequence_mapping_list/sequence_mapping_edit',

	pincodeMappingList: 'pincode_mapping_list',
	pincodeScheduleList: 'pincode_schedule_list',
	pincodeScheduleAdd: 'pincode_schedule_list/pincode_schedule_add',
	pincodeScheduleEdit: 'pincode_schedule_list/pincode_schedule_edit',
	pincodeMappingAdd: 'pincode_mapping_list/pincode_mapping_add',
	pincodeMappingEdit: 'pincode_mapping_list/pincode_mapping_edit',

	pincodeListing: 'pincode_listing',

	pincodeAreaMappingList: 'pincode_area_mapping_list',
	pincodeAreaMappingAdd: 'pincode_area_mapping_list/pincode_area_mapping_add',
	pincodeAreaMappingEdit: 'pincode_area_mapping_list/pincode_area_mapping_edit',

	shippingChargesList: 'shipping_charges_list',
	shippingChargesAdd: 'shipping_charges_list/shipping_charges_add',
	shippingChargesEdit: 'shipping_charges_list/shipping_charges_edit',

	downloadList: 'downloads_list',
	downloadAdd: 'downloads_list/downloads_add',
	downloadEdit: 'downloads_list/downloads_edit',

	bannerList: 'banners_list',
	cacheManager: 'cache_manager',
	bannerAdd: 'banners_list/banners_add',
	bannerEdit: 'banners_list/banners_edit',

	notificationCategoryList: 'notification_category_list',
	notificationCategoryAdd: 'notification_category_list/notification_category_add',
	notificationCategoryEdit: 'notification_category_list/notification_category_edit',

	notificationList: 'notification_list',
	notificationAdd: 'notification_list/notification_add',
	notificationEdit: 'notification_list/notification_edit',

	sendNotificationList: 'send_notification_list',
	sendNotificationAdd: 'send_notification_list/send_notification_add',
	sendNotificationView: 'send_notification_list/send_notification_view',

	// Targeted Notification
	targetedNotificationList: 'targeted_notification_list',
	targetedNotificationAdd: 'targeted_notification_list/targeted_notification_add',
	targetedNotificationView: 'targeted_notification_list/targeted_notification_view',

	// Notification Templates
	notificationTemplateList: 'notification_templates',
	notificationTemplateAdd: 'notification_templates/add',
	notificationTemplateEdit: 'notification_templates/edit',

	// AB Scheduled Messages
	abScheduledMessagesList: 'ab_scheduled_messages_list',
	abScheduledMessagesAdd: 'ab_scheduled_messages_list/ab_scheduled_message_add',
	abScheduledMessagesEdit: 'ab_scheduled_messages_list/ab_scheduled_message_edit',

	settingsList: 'settings',

	// mdm configuration
	mdmSettingsList: 'mdm-settings',

	productSectionsList: 'products_section_list',
	productsSectionsAdd: 'products_section_list/products_section_add',
	productsSectionsEdit: 'products_section_list/products_section_edit',

	manageMenuList: 'menu_management_list',
	manageMenuListAdd: 'menu_management_list/menu_management_add',
	manageMenuListEdit: 'menu_management_list/menu_management_edit',

	manageProfileMenuList: 'profile_modules_management_list',
	manageProfileMenuListAdd: 'profile_modules_management_list/add',
	manageProfileMenuListEdit: 'profile_modules_management_list/edit',

	featuredCategory: 'featured_category',
	featuredCategoryDetails: 'featured_category/featuredCategoryDetails',

	mediaCategory: 'media_category',
	mediaCategoryAdd: 'media_category/media_category_add',
	mediaCategoryEdit: 'media_category/media_category_edit',

	mediaContentList: 'media_content',
	mediaContentAdd: 'media_content/media_content_add',
	mediaContentEdit: 'media_content/media_content_edit',

	abMessageList: 'ab_messages_list',
	abMessageListAdd: 'ab_messages_list/ab_message_add',
	abMessageListEdit: 'ab_messages_list/ab_message_edit',

	downloadCategoryList: 'download_category_list',
	downloadCategoryAdd: 'download_category_list/download_category_add',
	downloadCategoryEdit: 'download_category_list/download_category_edit',

	downloadLanguageList: 'download_language_list',
	downloadLanguageAdd: 'download_language_list/download_language_add',
	downloadLanguageEdit: 'download_language_list/download_language_edit',

	contentTypeList: 'content_type_list',
	contentTypeAdd: 'content_type_list/content_type_add',
	contentTypeEdit: 'content_type_list/content_type_edit',

	voucherList: 'voucher_list',
	voucherAdd: 'voucher_list/voucher_add',
	voucherEdit: 'voucher_list/voucher_edit',

	purchaseRulesList: 'purchase_rules_list',

	eventsList: 'events_list',
	ulpTarget: 'ulp_target',
	eventsAdd: 'events_list/events_add',
	eventsEdit: 'events_list/events_edit',

	meetingsList: 'meetings_list',
	meetingsAdd: 'meetings_list/meetings_add',
	meetingsEdit: 'meetings_list/meetings_edit',

	marketingPlanLanguageList: 'marketing_plan_language_list',
	marketingPlanLanguageAdd: 'marketing_plan_language_list/marketing_plan_language_add',
	marketingPlanLanguageEdit: 'marketing_plan_language_list/marketing_plan_language_edit',

	marketingPlanList: 'marketing_plan_list',
	marketingPlanAdd: 'marketing_plan_list/marketing_plan_add',
	marketingPlanEdit: 'marketing_plan_list/marketing_plan_edit',

	sizeChartList: 'size_chart_list',
	ecomContactList: 'ecom_contact_list',
	sizeChartAdd: 'size_chart_list/size_chart_add',
	sizeChartEdit: 'size_chart_list/size_chart_edit',

	generalPagesList: 'general_pages_list',
	generalPagesAdd: 'general_pages_list/general_pages_add',
	generalPagesEdit: 'general_pages_list/general_pages_edit',

	aboutUsHistoryList: 'about_us_history_list',
	aboutUsHistoryAdd: 'about_us_history_list/about_us_history_add',
	aboutUsHistoryEdit: 'about_us_history_list/about_us_history_edit',

	noticesList: 'notices_list',
	noticeAdd: 'notices_list/notice_add',
	noticeEdit: 'notices_list/notice_edit',

	abUnstop: 'ab-unstop',
	kycReportsViewLogs: 'kyc-reports-view-logs',
	increaseMobileCount: 'increase-mobile-count',

	complianceDocumentsList: 'compliance_documents_list',
	complianceDocumentsAdd: 'compliance_documents_list/compliance_documents_add',
	complianceDocumentsEdit: 'compliance_documents_list/compliance_documents_edit',

	faqsList: 'faqs_list',
	faqsAdd: 'faqs_list/faqs_add',
	faqsEdit: 'faqs_list/faqs_edit',

	executivesList: 'executives_list',
	executiveAdd: 'executives_list/executive_add',
	executiveEdit: 'executives_list/executive_edit',
	offerImpactReport: 'offer_impact_report',
	remarksMaster: 'remarks_master',
	remarkModulesMaster: 'remark_modules_master',
	grandGrowthAwardLeaders: 'grand-growth-award/leaders',
	grandGrowthAwardReports: 'grand-growth-award/reports',
	grandGrowthAwardReportAssign: 'grand-growth-award/assign',
	grandGrowthAwardEligibility: 'grand-growth-award/eligibility-manager',
	grandGrowthAwardLevel1Check: 'grand-growth-award/level1-check',
	grandGrowthAwardLevel2Check: 'grand-growth-award/level2-check',
	grandGrowthAwardFinalExport: 'grand-growth-award/final-export',

	//employee
	employeeList: 'employee_list',
	employeeAdd: 'employee_list/employee_add',
	employeeEdit: 'employee_list/employee_edit',

	//manage banks
	bankList: 'manage_bank',
	bankAdd: 'manage_bank/bank_add',
	bankEdit: 'manage_bank/bank_edit',

	// update gst
	updateGst: 'update-gst',

	//manage branches
	branchList: 'manage_bank_branches',
	branchAdd: 'manage_bank_branches/branch_add',
	branchEdit: 'manage_bank_branches/branch_edit',

	//manage ecom user
	ecomUserPermissionList: 'ecom_user_permission_list',
	ecomUserPermissionAdd: 'ecom_user_permission_list/ecom_user_permission_add',
	ecomUserPermissionEdit: 'ecom_user_permission_list/ecom_user_permission_edit',

	// manage reports
	Aparajita: 'aparajita',
	purchaserInYourGroup: 'purchaser_in_your_group',
	RupantaranYatraDelhi: 'rupantaran-yatra-delhi',
	specialWomenRegistration: 'reports/special-women-registration',
	RCMDisplayWallReport: 'rcm-display-wall-report',
	PUCReport: 'puc-report',
	ABKycStatus: 'ab-kyc-status',
	UserDetails: 'user-details',
	ConsistencyDashboard: 'consistency-dashboard',
	Plantations: 'plantations',
	BloodDonors: 'blood-donors',
	productCategoryReport: 'product-category-report',
	cartProductsReport: 'cart-products-report',
	reportViewLogs: 'report-view-logs',
	userActivityLogs: 'user-activity-logs',
	monthlyStatement: 'monthly-statement',
	abGrowthReport: 'ab-growth-report',
	ulpProgramReport: 'ulp-program-report',
	zonalProgramReport: 'zonal-program-report',
	productPriceList: 'product-price-list',
	internalReportViewLogs: 'internal-report-view-logs',
	stoLoadingHistory: 'sto-loading-history',
	stoAllowedProducts: 'sto-allowed-products',

	// Kyc module
	declareReport: 'kyc_delete_pan_details',

	// Depots
	depotList: 'depot-list',
	depotAdd: 'depot-list/depot-add',
	depotEdit: 'depot-list/depot-edit',

	// Miscellaneous
	registeredBuyer: 'registered-buyer',
	normalBuyer: 'normal-buyer',
	duplicateRecord: 'duplicate-record',
	abSponsorAllowMisuse: 'ab-sponsor-allow-misuse',

	// kyc history
	nameHistory: 'name-history',
	mobileHistory: 'mobile-history',
	emailHistory: 'email-history',
	bankHistory: 'bank-pan-history',
	// panHistory: "pan-history",
	addressHistory: 'address-history',
	terminationHistory: 'terminate-history',
	notOkHistory: 'not-ok-history',
	yourGroup: 'your_group',
	productPurchase: 'product_purchase',
	productPurchaseMonthly: 'product-purchase-monthly',
	lastMonthPVDatewise: 'last_month_p_v_datewise',
	purchaseVolumeCalculator: 'purchase-volume-calculator',
	// taxInvoice: "tax-invoice",
	gstInvoice: 'gst-invoice',
	technicalGroupStructure: 'technical-group-structure',

	// Zonal
	zonalSalesUser: 'zonal-sales-user',
	zonalObservation: 'zonal-observation',

	// store feedback
	storeFeedback: 'store-feedback',

	// schedule management
	scheduleManagement: 'schedule-management',

	// post purchase feedback
	postPurchaseFeedback: 'post-purchase-feedback',

	// new joiner feedback
	newJoinerFeedback: 'new-joiner-feedback',

	// Targeted Voice Broadcast
	voiceBroadcastList: 'voice_broadcast_list',
	voiceBroadcastAdd: 'voice_broadcast_list/voice_broadcast_add',
	voiceBroadcastView: 'voice_broadcast_list/voice_broadcast_view',
	voiceBroadcastReport: 'voice_broadcast_list/voice_broadcast_report',
	// Hygiene Campaigns report
	HygieneCampaigns: 'hygiene-campaigns',

	// change password
	changePassword: 'change-password',

	// Mashal Report
	mashalReport: 'mashal-report',

	// Gooddot Rasoi
	manageGooddotRasoiBatch: 'manage-gooddot-rasoi-batch',
	manageGooddotRasoiApplications: 'manage-gooddot-rasoi-applications',
	gooddotRasoiReport: 'manage-gooddot-rasoi-report',
	gooddotRasoiAdd: 'manage-gooddot-rasoi-batch/add',
	gooddotRasoiEdit: 'manage-gooddot-rasoi-batch/edit',
	gooddotRasoiView: 'manage-gooddot-rasoi-batch/view',

	// Sehat ke Sitaare
	sehatKeSitaare: 'sehat-ke-sitaare',

	// Sehat Mitra
	sehatMitra: 'sehat-mitra',

	// Disease Management
	diseaseManagement: 'disease-management',

	// Sehat ke Sitaare Report
	sehatKeSitaareReport: 'sehat-ke-sitaare/view-report',

	// Sehat Mitra Report
	sehatMitraReport: 'sehat-mitra/view-report',

	// Sehat Mitra Course Registration Report
	sehatMitraCourseReport: 'sehat-mitra-course',

	// Post / Courier receipt module
	postList: 'post',
	postAdd: 'post/add',
	postAddOutward: 'post/add-outward',
	postEdit: 'post/edit',
	postView: 'post/view',
	postReport: 'post/report',
	postDashboard: 'post/dashboard',
	postCouriers: 'post/couriers',

	// QR Generator — carton sticker printing
	qrGenerator: 'qr-generator',
	qrGeneratorHistory: 'qr-generator/history',

	// Consistency Calculator — 6-month PV → wallet credit
	consistencyCalculator: 'consistency-calculator',
	consistencyUpload: 'consistency-calculator/upload',
	consistencyPeriods: 'consistency-calculator/periods',

	// Cash Bonus — 6-month sustained PV → flat reward
	cashBonusCalculator: 'cash-bonus',
	cashBonusUpload: 'cash-bonus/upload',
	cashBonusPeriods: 'cash-bonus/periods',

	// Sewa Diwas Paths
	sewaDiwasPreEvents: 'sewa-diwas/pre-events',
	sewaDiwasPostEvents: 'sewa-diwas/post-events',
	sewaDiwasDigitalMaterials: 'sewa-diwas/digital-materials',
	sewaDiwasReports: 'sewa-diwas/reports',
	sewaDiwasRatings: 'sewa-diwas/ratings',

	// Genie Paths
	genieCompanyTarget: 'genie-company-targets',
	genieCompanyTargetAdd: 'genie-company-targets/add',
	genieCompanyTargetEdit: 'genie-company-targets/edit',

	genieActivity: 'genie-activity',
	genieActivityAdd: 'genie-activity/add',
	genieActivityEdit: 'genie-activity/edit/:slug',

	genieActivityTarget: 'genie-activity-targets',
	genieActivityTargetAdd: 'genie-activity-targets/add',

	genieSkillDevelopmentTarget: 'genie-skill-development-targets',
	genieSkillDevelopmentTargetAdd: 'genie-skill-development-targets/add',
	genieSkillDevelopment: 'genie-skill-development-targets',

	genieGmv: 'genie-gmv',
	genieGmvAdd: 'genie-gmv/add',
	genieGmvEdit: 'genie-gmv/edit',

	genieSettings: 'genie-settings',

	genieTargetReport: 'genie-target-report',
	genieAchievementReport: 'genie-achievement-report',

	// Sehat mitra Course section
	manageSehatMitraCourseBatch: 'manage-sehat-mitra-course-batch',
	manageSehatMitraCourseBatchAdd: 'manage-sehat-mitra-course-batch/add',
	manageSehatMitraCourseBatchEdit: 'manage-sehat-mitra-course-batch/edit',
	manageSehatMitraCourseReport: 'manage-sehat-mitra-course-report',

	genieReviewAndApproval: 'genie-review-and-approval',

	geniePillarMapping: 'genie-pillar-mapping',
	geniePillarMappingAdd: 'genie-pillar-mapping/add',
	reportAnalytics: 'report-analytics',

	driveRevenueReport: 'drive-revenue-report',
	driveRevenueTarget: 'drive-revenue-target',
	driveReactivationReport: 'drive-reactivation-report',
	driveMISReport: 'drive-mis-report',
	driveRepurchaserTargetList: 'drive-repurchaser-target',
	driveRepurchaserTargetAdd: 'drive-repurchaser-target/add',
	driveRepurchaserTargetEdit: 'drive-repurchaser-target/edit/:id',
	driveRepurchaserReport: 'drive-repurchaser-report',

	southCeremonyEventLeaders: 'south-ceremony-event/leaders',
	southCeremonyEventReportAssignments: 'south-ceremony-event/assign',

	authenzaClubAnalytics: 'authenzaa-club-pre-launch/analytics',
	authenzaClubNotifyMe: 'authenzaa-club-pre-launch/notify-me',
};

export const publicPaths = ['/', '*', 'admin'];
